// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","accentDarker":"#a8bd2a","toggleOuter":"_2kp_","toggle":"_3JFk","toggleSwitch":"MTxr","active":"WK_A","activeText":"_3zA0"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PricingTable/PricingTable.scss
// module id = Q7J+
// module chunks = 0